import moment from "moment";
import { User } from "type/shipment";
import { formatMoney } from "./formatMoney";

 interface Props{
    shipments: User[],
    setDownloadingCSV: React.Dispatch<React.SetStateAction<boolean>>;
 }
function escapeCSV(value: any) {
    if (value == null || value === undefined) return "";
    return `"${String(value).replace(/"/g, '""')}"`; // Escape quotes & wrap
  }
 export const downloadCSV=({shipments, setDownloadingCSV}:Props) =>{
    const headers = [
      "Order date",
      "Order ID",
      "Status",
      "Recipient Name",
      "Recipient Address",
      "Recipient Phone",
      "Recipient Email",
      "Cost",
      "Pay on Delivery",
      "POD Amount",
      "Return Reason",
      "Created By",
      "Pick Up Date",
      "Dispatch Date",
      "Delivery Date",
      "Additional Note",
    ];

    if (shipments.length > 0) {
      setDownloadingCSV(true);

      const rows = shipments.map((shipment) => [
        escapeCSV(
          shipment.orderDate
            ? moment(shipment.orderDate).format("DD MMM, YYYY")
            : "N/A"
        ),
        escapeCSV(shipment.orderNo),
        escapeCSV(shipment.orderStatus),
        escapeCSV(shipment.recipientName),
        escapeCSV(shipment.recipientAddress),
        escapeCSV(shipment.recipientPhone),
        escapeCSV(shipment.recipientEmail),
        escapeCSV(shipment.cost),
        escapeCSV(Boolean(Number(shipment.is_item_cod)) ? "True" : "False"),
        escapeCSV(`${shipment.currencySymbol}${formatMoney().format(shipment.cod_amount)}`),
        escapeCSV(shipment.returnReason),
        escapeCSV(shipment.createdBy),
        escapeCSV(
          shipment.pickUpDate
            ? moment(shipment.pickUpDate).format("DD MMM, YYYY")
            : "N/A"
        ),
        escapeCSV(
          shipment.dispatchDate
            ? moment(shipment.dispatchDate).format("DD MMM, YYYY")
            : "N/A"
        ),
        escapeCSV(
          shipment.deliveryDate
            ? moment(shipment.deliveryDate).format("DD MMM, YYYY")
            : "N/A"
        ),
        escapeCSV(shipment.additionalNote),
      ]);
   
      const csvContent =
        "\uFEFF" + 
        headers.join(",") +
        "\n" +
        rows.map((row) => row.join(",")).join("\n");
      const encodedUri = encodeURI("data:text/csv;charset=utf-8," + csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "shipments.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setDownloadingCSV(false);
    }
  }